import { AppStore } from 'src/store/store';
import { IProduct } from '../interfaces/product';
import { getCompareAction, getFavoritesAction } from '../store/Product/action';

export const saveToLocalStorage = (name: string, obj: Object) => {
  try {
    const data = JSON.stringify(obj);
    localStorage.setItem(name, data);
  } catch (e) {
    console.error(e);
  }
};

export const loadFromLocalStorage = (name: string) => {
  try {
    const data = localStorage.getItem(name) || '';
    return JSON.parse(data);
  } catch (e) {
    return null;
  }
};

export const addOrRemoveFavoriteProducts = (product: IProduct | undefined, store: AppStore) => {
  const favProducts = loadFromLocalStorage('favoriteProducts') || [];
  if (favProducts.findIndex((item: IProduct) => item.id === product?.id) !== -1) {
    const filtered = favProducts.filter((item: IProduct) => item.id !== product?.id);
    store.dispatch(getFavoritesAction(filtered));
    saveToLocalStorage('favoriteProducts', filtered);
  } else {
    saveToLocalStorage('favoriteProducts', [...favProducts, product]);
    store.dispatch(getFavoritesAction([...favProducts, product]));
  }
};

export const isFavorite = (product: IProduct | undefined, store: AppStore) => {
  const {
    products: { favorites },
  } = store.getState();
  return !!(favorites.findIndex((item: IProduct) => item?.id === product?.id) !== -1);
};

export const addOrRemoveCompareProducts = (product: IProduct | undefined, store: AppStore) => {
  const products = loadFromLocalStorage('compareProducts') || [];
  if (products.findIndex((item: IProduct) => item.id === product?.id) !== -1) {
    const filtered = products.filter((item: IProduct) => item.id !== product?.id);
    store.dispatch(getCompareAction(filtered));
    saveToLocalStorage('compareProducts', filtered);
  } else {
    saveToLocalStorage('compareProducts', [...products, product]);
    store.dispatch(getCompareAction([...products, product]));
  }
};

export const isInCompare = (product: IProduct | undefined, store: AppStore) => {
  const {
    products: { compareList },
  } = store.getState();
  return !!(compareList.findIndex((item: IProduct) => item?.id === product?.id) !== -1);
};
